import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogRef} from '@angular/material/dialog';
import {DialogFooterComponent} from '@app/shared/components/dialog/dialog-footer/dialog-footer.component';
import {DialogHeaderComponent} from '@app/shared/components/dialog/dialog-header/dialog-header.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'hypecast-form-deactivateable-dialog',
  imports: [TranslateModule, DialogHeaderComponent, DialogFooterComponent, MatButtonModule],
  templateUrl: './form-deactivateable-dialog.component.html',
  styleUrl: './form-deactivateable-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormDeactivateableDialogComponent {
  readonly dialogRef = inject(MatDialogRef<FormDeactivateableDialogComponent>);
}
